import React, { useState } from 'react';
import axiosInstance from "../axiosInstance";
import {  FaSpinner } from "react-icons/fa"; // Icons for success and error


const FoodGroupCategories = ({onFinish}) => {
    const [categories, setCategories] = useState(['']); // Initialize with an empty category
    const user = JSON.parse(localStorage.getItem('user'));
    const restaurantId = user.restaurantId;
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (index, value) => {
        const updatedCategories = [...categories];
        updatedCategories[index] = value;
        setCategories(updatedCategories);
    };

    const handleAddCategory = () => {
        setCategories([...categories, '']); // Add a new empty field
    };

    const handleRemoveCategory = (index) => {
        const updatedCategories = categories.filter((_, i) => i !== index);
        setCategories(updatedCategories);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const validCategories = categories.filter(category => category.trim() !== '');

        try {
            await axiosInstance.post('/api/restaurant/update-categories', {
                restaurantId,
                categories: validCategories,
            });

            //update local storage with menuCategoriesAdded
            const user = JSON.parse(localStorage.getItem('user'));
            user.menuCategoriesAdded = true;
            localStorage.setItem('user', JSON.stringify(user));


            onFinish();

            // Success handling (e.g., redirect or notification)
        } catch (error) {
            console.error('Error saving categories:', error);
            // Error handling
        }
        setSubmitting(false);
    };

    return (
        <div className="bg-gray-100 p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold text-center mb-4">
                Add Food Group Categories
            </h2>
            <p className="text-center text-gray-600 mb-4">
                Please add categories according to priority as they will show on the menu.
            </p>
            <form onSubmit={handleSubmit}>
                <div className="space-y-3">
                    {categories.map((category, index) => (
                        <div key={index} className="flex items-center">
                            <input
                                type="text"
                                value={category}
                                onChange={(e) => handleChange(index, e.target.value)}
                                placeholder={`Category ${index + 1}  (e.g., On tray, Burgers, Drinks, Desserts)`}
                                className="border rounded-lg p-2 flex-grow"
                                required
                            />
                            {categories.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => handleRemoveCategory(index)}
                                    className="ml-2 text-red-500"
                                >
                                    Remove
                                </button>
                            )}
                        </div>
                    ))}
                </div>
                <button
                    type="button"
                    onClick={handleAddCategory}
                    className="mt-3 text-blue-500"
                >
                    Add Another Category
                </button>
                <div className="mt-4 text-center">
                    <button
                        type="submit"
                        className="bg-blue-500 text-white py-2 px-4 rounded-lg"
                        onClick={handleSubmit}
                    >
                     {submitting  ? <FaSpinner size={25} className="animate-spin" /> :   "Save and Next Step" }
                    </button>
                </div>
            </form>
        </div>
    );
};

export default FoodGroupCategories;
